module.exports = __webpack_public_path__ + "media/step3@2x_a23242.png";